// Auth Constants
export const AUTHENTICATING_USER = 'AUTHENTICATING_USER';
export const AUTHENTICATING_USER_SUCCESS = 'AUTHENTICATING_USER_SUCCESS';
export const AUTHENTICATING_USER_FAILURE = 'AUTHENTICATING_USER_FAILURE';

export const SITEIDS_LOADING = 'SITEIDS_LOADING';
export const SITEIDS_SUCCESS = 'SITEIDS_SUCCESS';
export const SITEIDS_FAILURE = 'SITEIDS_FAILURE';

export const ADMIN_SITES_LOADING = 'ADMIN_SITES_LOADING';
export const ADMIN_SITES_SUCCESS = 'ADMIN_SITES_SUCCESS';
export const ADMIN_SITES_FAILURE = 'ADMIN_SITES_FAILURE';

export const CATEGORIES_LOADING = 'CATEGORIES_LOADING';
export const CATEGORIES_SUCCESS = 'CATEGORIES_SUCCESS';
export const CATEGORIES_FAILURE = 'CATEGORIES_FAILURE';

export const SET_MOBILE = 'SET_MOBILE';

export const CREATING_DASHBOARD = 'CREATING_DASHBOARD';
export const CREATING_DASHBOARD_SUCCESS = 'CREATING_DASHBOARD_SUCCES';
export const CREATING_DASHBOARD_FAILURE = 'CREATING_DASHBOARD_FAILURE';
export const RESET_CREATING_DASHBOARD_SUCCESS = 'RESET_CREATING_DASHBOARD_SUCCESS';

export const GETTING_DASHBOARDS_BY_SITE = 'GETTING_DASHBOARDS_BY_SITE';
export const GETTING_DASHBOARDS_BY_SITE_SUCCESS = 'GETTING_DASHBOARDS_BY_SITE_SUCCESS';
export const GETTING_DASHBOARDS_BY_SITE_FAILURE = 'GETTING_DASHBOARDS_BY_SITE_FAILURE';
export const RESET_GETTING_DASHBOARDS_BY_SITE = 'RESET_GETTING_DASHBOARDS_BY_SITE';

export const UPDATING_DASHBOARD = 'UPDATING_DASHBOARD';
export const UPDATING_DASHBOARD_SUCCESS = 'UPDATING_DASHBOARD_SUCCESS';
export const UPDATING_DASHBOARD_FAILURE = 'UPDATING_DASHBOARD_FAILURE';
export const RESET_UPDATING_DASHBOARD = 'RESET_UPDATING_DASHBOARD';

export const UPDATING_DASHBOARDS = 'UPDATING_DASHBOARDS';
export const UPDATING_DASHBOARDS_SUCCESS = 'UPDATING_DASHBOARDS_SUCCESS';
export const UPDATING_DASHBOARDS_FAILURE = 'UPDATING_DASHBOARDS_FAILURE';
export const RESET_UPDATING_DASHBOARDS = 'RESET_UPDATING_DASHBOARDS';

export const DELETING_DASHBOARD = 'DELETING_DASHBOARD';
export const DELETING_DASHBOARD_SUCCESS = 'DELETING_DASHBOARD_SUCCESS';
export const DELETING_DASHBOARD_FAILURE = 'DELETING_DASHBOARD_FAILURE';
export const RESET_DELETING_DASHBOARD = 'RESET_DELETING_DASHBOARD';

export const UPDATING_DASHBOARD_LINKS = 'UPDATING_DASHBOARD_LINKS';
export const UPDATING_DASHBOARD_LINKS_SUCCESS = 'UPDATING_DASHBOARD_LINKS_SUCCESS';
export const UPDATING_DASHBOARD_LINKS_FAILURE = 'UPDATING_DASHBOARD_LINKS_FAILURE';
export const RESET_UPDATING_DASHBOARD_LINKS = 'RESET_UPDATING_DASHBOARD_LINKS';

export const ADDING_INFO_ITEM = 'ADDING_INFO_ITEM';
export const ADDING_INFO_ITEM_SUCCESS = 'ADDING_INFO_ITEM_SUCCESS';
export const ADDING_INFO_ITEM_FAILURE = 'ADDING_INFO_ITEM_FAILURE';
export const RESET_ADDING_INFO_ITEM = 'RESET_ADDING_INFO_ITEM';

export const UPDATING_INFO_ITEM = 'UPDATING_INFO_ITEM';
export const UPDATING_INFO_ITEM_SUCCESS = 'UPDATING_INFO_ITEM_SUCCESS';
export const UPDATING_INFO_ITEM_FAILURE = 'UPDATING_INFO_ITEM_FAILURE';
export const RESET_UPDATING_INFO_ITEM = 'RESET_UPDATING_INFO_ITEM';

export const DELETING_INFO_ITEM = 'DELETING_INFO_ITEM';
export const DELETING_INFO_ITEM_SUCCESS = 'DELETING_INFO_ITEM_SUCCESS';
export const DELETING_INFO_ITEM_FAILURE = 'DELETING_INFO_ITEM_FAILURE';
export const RESET_DELETING_INFO_ITEM = 'RESET_DELETING_INFO_ITEM';

export const GETTING_DASHBOARD = 'GETTING_DASHBOARD';
export const GETTING_DASHBOARD_SUCCESS = 'GETTING_DASHBOARD_SUCCESS';
export const GETTING_DASHBOARD_FAILURE = 'GETTING_DASHBOARD_FAILURE';
export const RESET_GETTING_DASHBOARD = 'RESET_GETTING_DASHBOARD';

export const ADDING_LINK = 'ADDING_LINK';
export const ADDING_LINK_SUCCESS = 'ADDING_LINK_SUCCESS';
export const ADDING_LINK_FAILURE = 'ADDING_LINK_FAILURE';
export const RESET_ADDING_LINK = 'RESET_ADDING_LINK';

export const GETTING_LINK = 'GETTING_LINK';
export const GETTING_LINK_SUCCESS = 'GETTING_LINK_SUCCESS';
export const GETTING_LINK_FAILURE = 'GETTING_LINK_FAILURE';
export const RESET_GETTING_LINK = 'RESET_GETTING_LINK';

export const GETTING_URL = 'GETTING_URL';
export const GETTING_URL_SUCCESS = 'GETTING_URL_SUCCESS';
export const GETTING_URL_FAILURE = 'GETTING_URL_FAILURE';
export const RESET_GETTING_URL = 'RESET_GETTING_URL';

export const DELETING_LINK = 'DELETING_LINK';
export const DELETING_LINK_SUCCESS = 'DELETING_LINK_SUCCESS';
export const DELETING_LINK_FAILURE = 'DELETING_LINK_FAILURE';
export const RESET_DELETING_LINK = 'RESET_DELETING_LINK';

export const EDITING_LINK = 'EDITING_LINK';
export const EDITING_LINK_SUCCESS = 'EDITING_LINK_SUCCESS';
export const EDITING_LINK_FAILURE = 'EDITING_LINK_FAILURE';
export const RESET_EDITING_LINK = 'RESET_EDITING_LINK';

export const SENDING_APP_FEEDBACK = 'SENDING_APP_FEEDBACK';
export const SENDING_APP_FEEDBACK_SUCCESS = 'SENDING_APP_FEEDBACK_SUCCESS';
export const SENDING_APP_FEEDBACK_FAILURE = 'SENDING_APP_FEEDBACK_FAILURE';
export const RESET_SENDING_APP_FEEDBACK = 'RESET_SENDING_APP_FEEDBACK';

export const SENDING_CONTACT_REQUEST = 'SENDING_CONTACT_REQUEST';
export const SENDING_CONTACT_REQUEST_SUCCESS = 'SENDING_CONTACT_REQUEST_SUCCESS';
export const SENDING_CONTACT_REQUEST_FAILURE = 'SENDING_CONTACT_REQUEST_FAILURE';
export const RESET_SENDING_CONTACT_REQUEST = 'RESET_SENDING_CONTACT_REQUEST';

export const SENDING_LINK_FEEDBACK = 'SENDING_LINK_FEEDBACK';
export const SENDING_LINK_FEEDBACK_SUCCESS = 'SENDING_LINK_FEEDBACK_SUCCESS';
export const SENDING_LINK_FEEDBACK_FAILURE = 'SENDING_LINK_FEEDBACK_FAILURE';
export const RESET_SENDING_LINK_FEEDBACK = 'RESET_SENDING_LINK_FEEDBACK';

export const SENDING_LINK_REQUEST = 'SENDING_LINK_REQUEST';
export const SENDING_LINK_REQUEST_SUCCESS = 'SENDING_LINK_REQUEST_SUCCESS';
export const SENDING_LINK_REQUEST_FAILURE = 'SENDING_LINK_REQUEST_FAILURE';
export const RESET_SENDING_LINK_REQUEST = 'RESET_SENDING_LINK_REQUEST';

export const SENDING_LINK_HIT = 'SENDING_LINK_HIT';
export const SENDING_LINK_HIT_SUCCESS = 'SENDING_LINK_HIT_SUCCESS';
export const SENDING_LINK_HIT_FAILURE = 'SENDING_LINK_HIT_FAILURE';
export const RESET_SENDING_LINK_HIT = 'RESET_SENDING_LINK_HIT';

export const DELETING_DASHBOARDS = 'DELETING_DASHBOARDS';
export const DELETING_DASHBOARDS_SUCCESS = 'DELETING_DASHBOARDS_SUCCESS';
export const DELETING_DASHBOARDS_FAILURE = 'DELETING_DASHBOARDS_FAILURE';
export const RESET_DELETING_DASHBOARDS = 'RESET_DELETING_DASHBOARDS';

export const DELETING_LINKS = 'DELETING_LINKS';
export const DELETING_LINKS_SUCCESS = 'DELETING_LINKS_SUCCESS';
export const DELETING_LINKS_FAILURE = 'DELETING_LINKS_FAILURE';
export const RESET_DELETING_LINKS = 'RESET_DELETING_LINKS';

export const GETTING_MY_DASHBOARDS = 'GETTING_MY_DASHBOARDS';
export const GETTING_MY_DASHBOARDS_SUCCESS = 'GETTING_MY_DASHBOARDS_SUCCESS';
export const GETTING_MY_DASHBOARDS_FAILURE = 'GETTING_MY_DASHBOARDS_FAILURE';
export const RESET_GETTING_MY_DASHBOARDS = 'RESET_GETTING_MY_DASHBOARDS';

export const ADDING_CONTRIBUTOR = 'ADDING_CONTRIBUTOR';
export const ADDING_CONTRIBUTOR_SUCCESS = 'ADDING_CONTRIBUTOR_SUCCESS';
export const ADDING_CONTRIBUTOR_FAILURE = 'ADDING_CONTRIBUTOR_FAILURE';
export const RESET_ADDING_CONTRIBUTOR = 'RESET_ADDING_CONTRIBUTOR';

export const GETTING_CONTRIBUTORS_BY_DASHBOARD = 'GETTING_CONTRIBUTORS_BY_DASHBOARD';
export const GETTING_CONTRIBUTORS_BY_DASHBOARD_SUCCESS = 'GETTING_CONTRIBUTORS_BY_DASHBOARD_SUCCESS';
export const GETTING_CONTRIBUTORS_BY_DASHBOARD_FAILURE = 'GETTING_CONTRIBUTORS_BY_DASHBOARD_FAILURE';
export const RESET_GETTING_CONTRIBUTORS_BY_DASHBOARD = 'RESET_GETTING_CONTRIBUTORS_BY_DASHBOARD';

export const UPDATING_CONTRIBUTOR = 'UPDATING_CONTRIBUTOR';
export const UPDATING_CONTRIBUTOR_SUCCESS = 'UPDATING_CONTRIBUTOR_SUCCESS';
export const UPDATING_CONTRIBUTOR_FAILURE = 'UPDATING_CONTRIBUTOR_FAILURE';
export const RESET_UPDATING_CONTRIBUTOR = 'RESET_UPDATING_CONTRIBUTOR';

export const DELETING_CONTRIBUTOR = 'DELETING_CONTRIBUTOR';
export const DELETING_CONTRIBUTOR_SUCCESS = 'DELETING_CONTRIBUTOR_SUCCESS';
export const DELETING_CONTRIBUTOR_FAILURE = 'DELETING_CONTRIBUTOR_FAILURE';
export const RESET_DELETING_CONTRIBUTOR = 'RESET_DELETING_CONTRIBUTOR';

// DASHBOARD HIT
export const SENDING_DASHBOARD_HIT = 'SENDING_DASHBOARD_HIT';
export const SENDING_DASHBOARD_HIT_SUCCESS = 'SENDING_DASHBOARD_HIT_SUCCESS';
export const SENDING_DASHBOARD_HIT_FAILURE = 'SENDING_DASHBOARD_HIT_FAILURE';

export const UPLOADING_DASHBOARD_PHOTO = 'UPLOADING_DASHBOARD_PHOTO';
export const UPLOADING_DASHBOARD_PHOTO_SUCCESS = 'UPLOADING_DASHBOARD_PHOTO_SUCCESS';
export const UPLOADING_DASHBOARD_PHOTO_FAILURE = 'UPLOADING_DASHBOARD_PHOTO_FAILURE';
export const RESET_UPLOADING_DASHBOARD_PHOTO = 'RESET_UPLOADING_DASHBOARD_PHOTO';
export const DELETING_DASHBOARD_PHOTO = 'DELETING_DASHBOARD_PHOTO';
export const DELETING_DASHBOARD_PHOTO_SUCCESS = 'DELETING_DASHBOARD_PHOTO_SUCCESS';
export const DELETING_DASHBOARD_PHOTO_FAILURE = 'DELETING_DASHBOARD_PHOTO_FAILURE';
export const RESET_DELETING_DASHBOARD_PHOTO = 'RESET_DELETING_DASHBOARD_PHOTO';
export const TRIGGERED_BULK_UPLOAD = 'TRIGGERED_BULK_UPLOAD';

//user constansts
export const USER_FAVORITES_LOADING = 'USER_FAVORITES_LOADING';
export const GET_FAVORITES_SUCCESS = 'GET_FAVORITES_SUCCESS';
export const GET_FAVORITES_FAILURE = 'GET_FAVORITES_FAILURE';
export const ADDING_FAVORITE_DASHBOARD = 'ADDING_FAVORITE_DASHBOARD';
export const POST_FAVORITE_DASHBOARD_SUCCESS = 'POST_FAVORITE_DASHBOARD_SUCCESS';
export const POST_FAVORITE_DASHBOARD_FAILURE = 'POST_FAVORITE_DASHBOARD_FAILURE';
export const REMOVING_FAVORITE_DASHBOARD = 'REMOVING_FAVORITE_DASHBOARD';
export const REMOVE_FAVORITE_DASHBOARD_SUCCESS = 'REMOVE_FAVORITE_DASHBOARD_SUCCESS';
export const REMOVE_FAVORITE_DASHBOARD_FAILURE = 'REMOVE_FAVORITE_DASHBOARD_FAILURE';
